<template>
	<div class="newIntegration">
		<div class="breadcrumb">{{actionText}}奖品
			<span>
				<el-button class="right_f" type="primary" @click="save">保存</el-button>
				<el-button class="right_f" type="primary" @click="back">取消</el-button>
			</span>
		</div>

		<div>
			<el-form ref="inteForm" :rules="rules" :model="inteForm" label-width="140px">
				<el-form-item label="奖品名称：" prop="prizeName">
					<el-input v-model="inteForm.prizeName" placeholder="奖品名称" class="inputTitle"></el-input>
				</el-form-item>

				<el-form-item label="奖品图片：" prop="imgUrl" required>
					<el-upload :action="logoActionUrl" :with-credentials='true' accept="image/*" name="uploadFile" type="drag" :thumbnail-mode="true"
					 :on-error="handleError" :on-success="handleSuccess">
						<i class="el-icon-upload"></i>
						<div class="el-dragger__text">将文件拖到此处，或
							<em>点击上传</em>
						</div>
					</el-upload>
					<span class="gray">（尺寸说明：360×300像素，jpg、jpeg、png）</span>
				</el-form-item>
				<el-form-item label="中奖概率：" prop="probability" required>
					<el-input v-model.number="inteForm.probability" placeholder="中奖概率总和为100%" style="width: 250px;" class="probability">
						<template slot="append" style="line-height: 34px;">%</template>
					</el-input>
					<span style="color:red;">（可配置的最低中奖概率为0.01%）</span>
				</el-form-item>

				<el-form-item label="自动兑奖:" required>
					<el-radio v-model="inteForm.isAuto" label="1">是</el-radio>
					<el-radio v-model="inteForm.isAuto" label="0" class="inline">否</el-radio>
				</el-form-item>

				<el-form-item label="是否无限:" required>
					<el-radio v-model="inteForm.isInfinite" label="1">是</el-radio>
					<el-radio v-model="inteForm.isInfinite" label="0" class="inline">否</el-radio>
				</el-form-item>

				<el-form-item label="奖品库存:" prop="fileUrl">
					<el-upload :action="importAction" :with-credentials='true' style="display: inline-block" :on-success="success" :on-error="handleError"
					 name="uploadFile">
						<el-button>选择文件</el-button>
					</el-upload>
				</el-form-item>

				<el-form-item label="可中奖次数:" required>
					<el-radio v-model="inteForm.isLimit" label="0">不限</el-radio>
					<el-radio v-model="inteForm.isLimit" label="1" class="inline">限定</el-radio>
					<br>
					<el-input v-model="inteForm.drawHitCount" v-if='inteForm.isLimit=="1"' placeholder="请输入自定义数量" style="width: 250px;" class="probability">
						<template slot="append" style="line-height: 34px;">次</template>
					</el-input>
				</el-form-item>

				<el-form-item label="兑奖URL:" required>
					<el-radio v-model="inteForm.definePrizeUrl" label="false">不跳转</el-radio>
					<el-radio v-model="inteForm.definePrizeUrl" label="true" class="inline">自定义URL</el-radio>
					<br>
					<el-input v-model="inteForm.prizeUrl" v-if='inteForm.definePrizeUrl=="true"' class="inputTitle" placeholder="请输入自定义url"></el-input>
				</el-form-item>

				<el-form-item class="time" label="兑换开始时间：" prop="startTime">
					<el-date-picker v-model="inteForm.startTime" format="yyyy/MM/dd" placeholder="yyyy/MM/dd" class="qizhiDate"></el-date-picker>
				</el-form-item>

				<el-form-item class="time" label="兑换结束时间：" prop="endTime">
					<el-date-picker v-model="inteForm.endTime" format="yyyy/MM/dd" placeholder="yyyy/MM/dd" class="qizhiDate"></el-date-picker>
				</el-form-item>

				<el-form-item label="广告曝光代码:" class="prizeContent">
					<el-input type="textarea" :autosize="{minRows: 5}" placeholder="广告曝光代码" v-model="inteForm.adExposingCodes">
					</el-input>
				</el-form-item>

				<el-form-item label="文案类型：" class="prizeContent" required>
					<el-radio v-model="inteForm.isRedeem" label="1">兑奖码类型</el-radio>
					<el-radio v-model="inteForm.isRedeem" label="0" class="inline">自定义文案</el-radio>
				</el-form-item>

				<el-form-item label="文案：" class="prizeContent">
					<el-input type="textarea" :autosize="{minRows: 5}" placeholder="文案" v-model="inteForm.defineText">
					</el-input>
				</el-form-item>
			</el-form>

		</div>

	</div>
</template>
<script>
	import { mapState, mapActions } from "vuex";

	export default {
		data() {
			return {
				actionType: "0",
				actionText: "添加",
				logoActionUrl:
					this.$util.domain +
					"/adminapi/v1/basicTools/upload/one?uploadImageType=7",
				importAction:
					this.$util.domain +
					"/adminapi/v1/basicTools/upload/one?uploadImageType=7",
				dataList: [],
				inteForm: {
					id: "",
					position: this.$util.getUrlParam("position")
						? this.$util.getUrlParam("position") * 1
						: 1,
					prizeName: "",
					probability: "",
					imgUrl: "",
					prizeUrl: "",
					adExposingCodes: "",
					defineText: "",
					drawHitCount: "",
					startTime: "",
					endTime: "",
					fileUrl: "",
					isRedeem: "0",
					hasReplacePrize: "",
					isAuto: "1",
					isLimit: "0",
					isInfinite: "0",
					definePrizeUrl: "false"
				},
				rules: {
					prizeName: [
						{ required: true, message: "请填写奖品名称", trigger: "blur" }
					],
					imgUrl: [
						{ required: true, message: "请上传奖品图片", trigger: "change" }
					],
					probability: [
						{
							required: true,
							type: "number",
							message: "请正确填写中奖概率",
							trigger: "blur"
						}
					],
					fileUrl: [{ required: true, message: "请导入奖品", trigger: "change" }],
					startTime: [
						{
							type: "date",
							required: true,
							message: "请选择开始时间",
							trigger: "change"
						}
					],
					endTime: [
						{
							type: "date",
							required: true,
							message: "请选择结束时间",
							trigger: "change"
						}
					]
				}
			};
		},
		mounted() {
			let id = this.$util.getUrlParam("id");
			let isEdit = this.$util.getUrlParam("isEdit");
			this.dataList = JSON.parse(this.$util.getStore("prizeList"));

			if (isEdit == "false") {
				//新增
				this.inteForm.id = 0;
				this.actionType = "0";
			} else {
				//编辑
				this.actionType = "1";
				this.inteForm.id = id * 1;
				this.actionText = "编辑";
				this.getDet();
			}
		},
		methods: {
			//保存
			save() {
				//校验成功，调用添加方法；
				this.$refs.inteForm.validate(valid => {
					if (valid) {
						//存储本地
						this.submitLocalStorage();
					}
				});
			},
			//存储到本地
			submitLocalStorage() {
				let startTime = "",
					endTime = "",
					drawHitCount = 0;
				if (
					this.inteForm.definePrizeUrl == "true" &&
					!this.inteForm.prizeUrl.length
				) {
					this.$util.errorMsg("请填写自定义url");
					return;
				}

				if (this.inteForm.definePrizeUrl == "false") {
					this.inteForm.prizeUrl = "";
				}

				if (this.inteForm.isLimit == "0") {
					drawHitCount = -1; //不限次数
				} else {
					if (!this.inteForm.drawHitCount) {
						this.$util.errorMsg("请填写可中奖次数");
						return;
					}
					drawHitCount = this.inteForm.drawHitCount;
				}

				startTime = new Date(
					new Date(this.inteForm.startTime).format("yyyy-MM-dd 00:00:00")
				).getTime();
				endTime = new Date(
					new Date(this.inteForm.endTime).format("yyyy-MM-dd 23:59:59")
				).getTime();

				//获取表单数据
				let item = {
					id: this.inteForm.id,
					endTime: endTime,
					startTime: startTime,
					drawHitCount: drawHitCount,
					position: this.inteForm.position,
					prizeName: this.inteForm.prizeName,
					imgUrl: this.inteForm.imgUrl,
					probability: this.inteForm.probability * 100,
					definePrizeUrl: this.inteForm.definePrizeUrl,
					prizeUrl: this.inteForm.prizeUrl,
					adExposingCodes: this.inteForm.adExposingCodes,
					defineText: this.inteForm.isRedeem == 1 ? '' : this.inteForm.defineText,
					redeemText: this.inteForm.isRedeem == 1 ? this.inteForm.defineText : '',
					fileUrl: this.inteForm.fileUrl,
					isRedeem: this.inteForm.isRedeem,
					isAuto: this.inteForm.isAuto * 1,
					isInfinite: this.inteForm.isInfinite * 1,
					hasReplacePrize: this.dataList[this.inteForm.position * 1 - 1]
						.hasReplacePrize,
					prizeCount: this.dataList[this.inteForm.position * 1 - 1].prizeCount,
					operator: this.dataList[this.inteForm.position * 1 - 1].operator,
					operateTime: this.dataList[this.inteForm.position * 1 - 1].operateTime
				};

				//判断表单数据与本地数据是否一致，若一致，则用户未编辑；不一致，更新到本地
				if (
					!this.$util.isObjectValueEqual(
						item,
						this.dataList[this.inteForm.position - 1]
					)
				) {
					this.dataList[this.inteForm.position - 1] = item;

					this.$util.setStore("prizeList", this.dataList);

					let updateList = JSON.parse(this.$util.getStore("updateList")) || [];
					if (updateList.indexOf(this.inteForm.position - 1) < 0) {
						updateList.push(this.inteForm.position - 1);
					}

					this.$util.setStore("updateList", updateList);

					this.$util.successMsg("保存成功");

					this.cancel();
				} else {
					this.$util.errorMsg("请编辑后再保存");
				}
			},
			getDet() {
				//从本地获取详情并赋值给表单对象
				this.dataList.forEach(item => {
					if (this.inteForm.position == item.position) {
						this.inteForm = {
							id: item.id,
							position: item.position,
							prizeName: item.prizeName,
							probability: item.probability / 100,
							imgUrl: item.imgUrl,
							drawHitCount: item.drawHitCount == -1 ? 0 : item.drawHitCount,
							isLimit: item.drawHitCount == -1 ? "0" : "1",
							prizeUrl: item.prizeUrl,
							fileUrl: item.fileUrl,
							adExposingCodes: item.adExposingCodes,
							defineText: item.isRedeem == 1 ? item.redeemText : item.defineText,
							isRedeem: item.isRedeem + "",
							startTime: new Date(item.startTime),
							endTime: new Date(item.endTime),
							isAuto: item.isAuto + "",
							isInfinite: item.isInfinite + "",
							definePrizeUrl: item.definePrizeUrl + ""
						};
					}
				});
			},
			back() {
				this.$confirm(`取消添加将不保存编辑记录，是否继续取消`, "提示", {
					confirmButtonText: "是",
					cancelButtonText: "否",
					type: "warning"
				})
					.then(() => {
						this.cancel();
					})
					.catch(() => { });
			},
			cancel() {
				location.href = "/#/yunying/integration/integration?isFirst=1";
			},
			//上传picture文件成功钩子
			handleSuccess(response) {
				if (response.error !== 10000) {
					this.$util.errorMsg("上传失败");
				} else {
					this.$util.successMsg("导入成功");
					this.inteForm.imgUrl = response.data;
				}
			},
			success(response) {
				if (response.error !== 10000) {
					this.$util.errorMsg("上传失败");
				} else {
					this.$util.successMsg("导入成功");
					this.inteForm.fileUrl = response.data;
				}
			},
			//上传文件失败钩子
			handleError(response) {
				if (response.status === 403) {
					this.SIGNOUT();
					location.href = "/#";
				}
				this.$util.errorMsg("上传失败");
			}
		}
	};
</script>

<style>
	.inputTitle {
		width: 40%;
	}

	.qizhiDate {
		display: inline-block;
		width: 100%;
	}

	.newIntegration .time {
		width: 40%;
	}

	.newIntegration .campContain {
		width: 700px;
		height: 135px;
		border: solid 1px gray;
		box-sizing: border-box;
		overflow-y: scroll;
	}

	.newIntegration .irregular {
		display: inline-block;
	}

	.newIntegration .campSpan {
		display: block;
		text-align: center;
		float: left;
		height: 36px;
		padding: 0 30px 5px 15px;
		border: solid 1px #999;
		border-radius: 5px;
		margin: 10px;
		box-sizing: border-box;
		font-size: 12px;
		position: relative;
		cursor: pointer;
	}

	.gray {
		color: #999;
	}

	.campSpan i {
		width: 20px;
		height: 20px;
		line-height: 20px;
		color: #999;
		position: absolute;
		right: 5px;
		top: 5px;
	}

	.probability .el-input__inner {
		height: 38px;
	}

	.newIntegration .el-input-group__append {
		line-height: 34px;
		height: 34px;
	}
</style>


// WEBPACK FOOTER //
// newIntegration.vue?ef7c4d8c